const DialogRemoveSuperContent = {
  heading:
    'Confirming you want to remove superannuation as a splittable asset?',
  paragraph:
    'Removing superannuation as a splittable asset will mean you have to restart the division of assets.',
};

export default DialogRemoveSuperContent;
